import DisqusEmbed from './Embed';
import DisqusCommentCount from './CommentCount';

export { DisqusEmbed, DisqusCommentCount }
